export default {"src":"/developer/_next/static/media/success.a012578f.svg","height":200,"width":200,"blurWidth":0,"blurHeight":0};